 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"41cd0824091061b8d00a93738ccb5421aa057e33","2":"b1f56f956afaff65baf1d81e2bd79eaf601b6f42","3":"6375f2efe2a17fce46dd74ab79d5df36cc71823b","4":"component---src-pages-news-media-watch-index-tsx","5":"d503225ef50721abc73b3ad9314bf9422f8c072a","6":"6c7b3b7d85b002b4fe74c79ec8e622aae513abd4","7":"71d0b12397206139698dc659eed761cb5f842fdd","10":"component---src-pages-404-tsx","11":"component---src-pages-about-tsx","12":"component---src-pages-contact-tsx","13":"component---src-pages-detail-tsx","14":"component---src-pages-index-tsx","15":"component---src-pages-news-[id]-index-tsx","16":"component---src-pages-news-coverage-index-tsx","17":"component---src-pages-news-coverage-render-black-column-tsx","18":"component---src-pages-news-coverage-render-gray-small-column-tsx","19":"component---src-pages-news-coverage-render-navigation-tsx","20":"component---src-pages-news-coverage-render-purple-column-tsx","21":"component---src-pages-news-index-tsx","22":"component---src-pages-news-media-index-tsx","23":"component---src-pages-news-media-listen-index-tsx","24":"component---src-pages-news-media-read-index-tsx","25":"component---src-pages-news-news-list-index-tsx","26":"component---src-pages-news-research-index-tsx","27":"component---src-pages-portfolio-tsx","28":"component---src-pages-team-tsx","29":"ea88be26"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"c61a882246885e661555","2":"3ec2543981b5f9cb4d07","3":"94cea4204d9bf22eadf0","4":"482e3bf91f7b73f01f31","5":"56c10402564d16937db0","6":"04dc70fb5fcdadc4969f","7":"9041637dbf3f32ff1b11","10":"3c5c638d21746668a39d","11":"1807fad9c075c8104887","12":"19cc814719c21325807e","13":"c4e66a83cb70d32203fc","14":"36646daab28dfe5645ad","15":"1910d9a1a3e00abe47ba","16":"5c2ce990b1042e2bed28","17":"f5cda4a9533592d6dfa9","18":"110a0ea6700cff379209","19":"677638dfa021180c1d7e","20":"e785088cc90e69ee540c","21":"53e652089dc7d01593d7","22":"3d601294df1f33f2da5a","23":"67e07d6e0ec9143e5ccb","24":"100a1b09ac253faf23f0","25":"8e6cb3f7741cc0e5ad4e","26":"fd9425fdf2f5f9cef160","27":"66a30524f237766b4208","28":"82a4506ee29e2d8e05e8","29":"98f3150598ef5eb4aada","32":"50c37cedacae1217b16b","33":"9a20fd41da11496a616f","34":"a8f2daa1eeb5b047d3b0","35":"17e58ad216a9b357c8df","36":"510214415b875e8b42cf","37":"ffc7439f0defd4fe31b6","38":"ad05c89fe6ade785580f","39":"85eb4a6270ad8237cefa","40":"8ccd2df8dbe0c3e82fbd","41":"1e995d47490a757ebd3b","42":"60cfc12cbff562018d5c","43":"6399e0cc4a64b03b7fa6","44":"6fa1537c41f30625e689","45":"4b5e1788fdf3d851e897","46":"f458ace7adf1b51d54e8","47":"265929ba836d31016a16","48":"b50aa43795c311a72f72","49":"532d5d75cf594593df2e","50":"db03ced10425347b96a9","51":"de66f43f105c0505198d","52":"837340b1216375dc016b","53":"ffb01552578606c657d5","54":"919c2588ba93763f1052","55":"f0930a8710b4abfec870","56":"d1deaa40b2702859fd97","57":"58669caf6aa5640a6b83","58":"abb60d3e832c685a0dca","59":"73283bd7bd9086198bd9","60":"54b32ee79dbf0455edab","61":"032415d82f32bb462e99","62":"d2df834b3c5a5ff78ac5","63":"a460981c850c0b26d2a6","64":"db823d1e9428c452a1c4","65":"d852d65f17dae028e4b2","66":"b0d8b6d332f06aac4a8c","67":"c1d81068a3db9b9cd652","68":"6f34ca7e539618eef294","69":"d6e407b7f58db101f534","70":"701ca0e6932245666faf","71":"1fed17cf60306538fc47","72":"7c0311bcaf040d1d7777","73":"39d00f53d90d024d053b","74":"fc1efa3362f75dbbdbd3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"41cd0824091061b8d00a93738ccb5421aa057e33","2":"b1f56f956afaff65baf1d81e2bd79eaf601b6f42","3":"6375f2efe2a17fce46dd74ab79d5df36cc71823b","4":"component---src-pages-news-media-watch-index-tsx","5":"d503225ef50721abc73b3ad9314bf9422f8c072a","6":"6c7b3b7d85b002b4fe74c79ec8e622aae513abd4","7":"71d0b12397206139698dc659eed761cb5f842fdd","10":"component---src-pages-404-tsx","11":"component---src-pages-about-tsx","12":"component---src-pages-contact-tsx","13":"component---src-pages-detail-tsx","14":"component---src-pages-index-tsx","15":"component---src-pages-news-[id]-index-tsx","16":"component---src-pages-news-coverage-index-tsx","17":"component---src-pages-news-coverage-render-black-column-tsx","18":"component---src-pages-news-coverage-render-gray-small-column-tsx","19":"component---src-pages-news-coverage-render-navigation-tsx","20":"component---src-pages-news-coverage-render-purple-column-tsx","21":"component---src-pages-news-index-tsx","22":"component---src-pages-news-media-index-tsx","23":"component---src-pages-news-media-listen-index-tsx","24":"component---src-pages-news-media-read-index-tsx","25":"component---src-pages-news-news-list-index-tsx","26":"component---src-pages-news-research-index-tsx","27":"component---src-pages-portfolio-tsx","28":"component---src-pages-team-tsx","29":"ea88be26"}[chunkId]||chunkId) + "." + {"0":"0d58c2eab6b7b21dadc0","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
